import { Injectable } from '@angular/core';
import { APIKey, apiKeyDecoder, apiKeyEncoder } from '../models/api-key';
import { HttpServiceBuilder, HttpServiceConfig } from '../util/http.service';
import { EntityService } from '../util/entity.service';

@Injectable({
  providedIn: 'root',
})
export class APIKeysService extends EntityService<APIKey, {}> {
  constructor(httpServiceBuilder: HttpServiceBuilder<APIKey>) {
    super(httpServiceBuilder, 'api_keys', apiKeyDecoder);
  }

  getEncoder(): (entity: APIKey) => {} {
    return apiKeyEncoder;
  }

  getCreateConfig(apiKey: APIKey): HttpServiceConfig<APIKey> {
    return {
      ...super.getCreateConfig(apiKey),
      route: this.getRouteFromType(apiKey.type),
    };
  }

  private getRouteFromType(type: string): string {
    return `api_key/${type}`;
  }
}
